import React from 'react';
import './styles/proces.css';
import CTAKnap, { CTAIkoner } from './ctaknap';

// Moderne, elegante SVG-ikoner
const StepIkoner = {
  search: (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <circle cx="11" cy="11" r="8"/>
      <path d="m21 21-4.35-4.35"/>
    </svg>
  ),
  design: (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
    </svg>
  ),
  code: (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <polyline points="16 18 22 12 16 6"/>
      <polyline points="8 6 2 12 8 18"/>
      <line x1="15" y1="4" x2="9" y2="20"/>
    </svg>
  ),
  rocket: (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"/>
      <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"/>
      <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"/>
      <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"/>
    </svg>
  )
};

const Proces = () => {
  const processSteps = [
    {
      number: '01',
      title: 'Først og fremmest: Vi forstår din forretning',
      description: 'Alt starter med en god snak. Vi sætter os grundigt ind i din virksomhed, dine kunder og din branche. Målet er ikke bare at bygge en hjemmeside, men at lægge det rigtige digitale fundament, der passer præcis til dine mål og behov.',
      icon: StepIkoner.search,
      color: '#1e3a8a',
      gradient: 'linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)'
    },
    {
      number: '02',
      title: 'Design, der skaber tillid (og stolthed!)',
      description: 'Her giver vi din virksomhed et digitalt ansigt. Vi designer et professionelt og indbydende layout, der afspejler din identitet og gør det nemt og behageligt for dine kunder at navigere på siden. Du skal være stolt af at vise din nye hjemmeside frem.',
      icon: StepIkoner.design,
      color: '#059669',
      gradient: 'linear-gradient(135deg, #059669 0%, #10b981 100%)'
    },
    {
      number: '03',
      title: 'Teknikken, der bare virker',
      description: 'Vi bygger din hjemmeside med moderne og gennemtestet teknologi. Det betyder, at den er hurtig, sikker og fungerer på alle enheder – fra mobil til computer. Samtidig sørger vi for, at den er bygget korrekt op, så nye kunder har lettere ved at finde dig på Google.',
      icon: StepIkoner.code,
      color: '#dc2626',
      gradient: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)'
    },
    {
      number: '04',
      title: 'En god start og en tryg fremtid',
      description: 'Når alt er klar, lancerer vi din nye hjemmeside. Men du behøver ikke at slippe os her.  Vi står klar med support, hvis der skulle opstå spørgsmål. Din tryghed og trivsel er vores prioritet.',
      icon: StepIkoner.rocket,
      color: '#7c3aed',
      gradient: 'linear-gradient(135deg, #7c3aed 0%, #a855f7 100%)'
    }
  ];

  return (
    <section className="proces">
      <div className="container">
        <div className="proces-header">
          <h2 className="proces-title">
            Fra god idé til en <span className="highlight">hjemmeside, der virker for dig</span>
          </h2>
          <p className="proces-subtitle">
            Vi tror på, at den bedste hjemmeside bliver skabt i et tæt samarbejde. Derfor har vi en enkel og gennemskuelig proces i fire trin, der sikrer, at vi kommer trygt i mål sammen, og at du får en løsning, der skaber værdi for din forretning.
          </p>
        </div>

        <div className="proces-flow">
          {processSteps.map((step, index) => (
            <div key={step.number} className="proces-step">
              <div className="step-circle" style={{ background: step.gradient }}>
                <div className="step-icon">
                  {step.icon}
                </div>
                <div className="step-number">{step.number}</div>
              </div>
              
              <div className="step-content">
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
              </div>

              {index < processSteps.length - 1 && (
                <div className="step-connector">
                  <div className="connector-line"></div>
                  <div className="connector-arrow">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <polyline points="9 18 15 12 9 6"/>
                    </svg>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="proces-cta">
          <CTAKnap 
            variant="primary" 
            size="large"
            href="/kontakt"
            icon={<CTAIkoner.ArrowRight />}
          >
            Start dit projekt
          </CTAKnap>
          <CTAKnap 
            variant="outline" 
            size="large"
            href="/tjenester"
            icon={<CTAIkoner.BarChart />}
          >
            Se alle tjenester
          </CTAKnap>
        </div>
      </div>
    </section>
  );
};

export default Proces;
